// @flow
import React from "react";
import cx from "classnames";
import glamorous from "glamorous";
import SvgIcon from "root/components/SvgIcon";
import SVG_ICONS from "~/assets/icons/icons";


type propsType = {
    checked?: boolean,
    disabled?: boolean,
    className?: string,
    onClick?: ?Function,
    size? : number,
    borderWidth?: number,
    borderRadius?: number,
    borderColor?: string,
    activeThemeColor?: string,
}


export const Checkbox = ({
	checked, disabled, className, size = 16, borderWidth = 1, borderRadius = 4, borderColor, onClick, activeThemeColor = "action",
}: propsType) => {
	const GCheckbox = glamorous.div(cx(
		"ba dib",
		className,
		{
			[`bg-${activeThemeColor} bg-${activeThemeColor}-c bc-${activeThemeColor}`]: checked,
			"bc-menu-icons": !checked,
			"o-70": disabled,
		},
	),
	{
		label: "checkbox",
		borderRadius,
		borderWidth,
		padding: 0,
		width: size,
		height: size,
	},
	() => ({
		borderColor: !checked ? borderColor : null,
	}));

	return (
		<GCheckbox data-test="checkbox" disabled={disabled} onClick={(e) => {
			if (onClick && !disabled) {
				onClick(e);
			}
		}}>
			{ checked && <SvgIcon path={SVG_ICONS.CHECKED} colorName={`bg-${activeThemeColor}`}/>}
		</GCheckbox>
	);
};

export default Checkbox;
